<template>
    <tr>
        <td>
            <router-link :to="`/resources/${resource.id}/basics`">
                {{ resource.title }}
            </router-link>
        </td>
        <td>
            {{ resource.user.firstName }} {{ resource.user.lastName }}, {{ (resource.organization) ? resource.organization.name : '' }}
        </td>
        <td>{{ resource.status | capitalize }}</td>

    </tr>
</template>

<script>
    export default {
        name: 'AdminTableItem',
        props: {
            resource: Object
        },
        components:{},
        data: () => ({

        }),
        computed: {},
        watch: {},
        methods: {},
        mounted() {}
    }
</script>
